export class ScreenVendorManager {
    constructor() {
        this.screenVendors = new Map();
    }
    registerScreenVendor(name, screenVendor) {
        this.screenVendors.set(name, screenVendor);
    }
    getScreenVendor(name) {
        return this.screenVendors.get(name);
    }
    async restartScreens(device) {
        const entries = Array.from(this.screenVendors.entries());
        const results = await Promise.all(entries.map(([name, vendor]) => Promise.resolve(vendor.restartScreens(device))
            .then(() => ({ vendor: name }))
            .catch((error) => ({ vendor: name, error }))));
        return results;
    }
}
//# sourceMappingURL=ScreenVendorManager.js.map